import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import * as XLSX from "xlsx";

const ExcelTemplate = ({ trigger }) => {
  const downloadTemplate = () => {
    const templateData = [
      // Header row with all available fields
      [
        "Title",
        "Author(s)",
        "Edition",
        "Document Type",
        "Language",
        "Published Year",
        "Publisher",
        "ISBN",
        "Call Number",
        "Subjects/Genre",
        "Keywords",
        "Tags",
        "Number of Pages",
        "Abstract/Description",
        "Notes/Additional Info",
        "Physical Description",
        "Table of Content",
        "Source",
      ],
      // Example 1: Complete book entry
      [
        "The Great Gatsby",
        "Fitzgerald, F. Scott",
        "1st Edition",
        "BOOK",
        "English",
        "1925",
        "Charles Scribner's Sons",
        "978-0-7432-7356-5",
        "813.52 F553 1925",
        "American Literature, Classic Fiction",
        "Jazz Age, American Dream",
        "classic, literature, 1920s",
        "180",
        "A novel set in the Jazz Age that explores themes of wealth, love, and the American Dream through the mysterious millionaire Jay Gatsby.",
        "First edition reprint",
        "Hardcover, 180 pages",
        "Chapter 1: Introduction\nChapter 2: The Valley of Ashes\nChapter 3: Gatsby's Party",
        "Library Purchase 2024",
      ],
      // Example 2: Scientific publication
      [
        "Introduction to Algorithms",
        "Cormen, Thomas H.; Leiserson, Charles E.; Rivest, Ronald L.; Stein, Clifford",
        "4th Edition",
        "BOOK",
        "English",
        "2022",
        "MIT Press",
        "978-0-262-04630-5",
        "005.1 C817 2022",
        "Computer Science, Algorithms, Programming",
        "data structures, complexity analysis",
        "algorithms, computer science, textbook",
        "1312",
        "A comprehensive textbook covering algorithms and data structures with mathematical analysis.",
        "Standard CS textbook",
        "Hardcover, 1312 pages, includes CD-ROM",
        "Part I: Foundations\nPart II: Sorting and Order Statistics\nPart III: Data Structures",
        "Donation 2023",
      ],
      // Example 3: Minimal entry showing required vs optional fields
      [
        "Modern Poetry Collection",
        "Various Authors",
        "",
        "BOOK",
        "English",
        "2023",
        "Independent Press",
        "",
        "811 M6234 2023",
        "Poetry, Contemporary Literature",
        "",
        "",
        "256",
        "An anthology of contemporary poetry from emerging voices.",
        "",
        "",
        "",
        "",
      ],
      // Example 4: Foreign language book
      [
        "Cien Años de Soledad",
        "García Márquez, Gabriel",
        "1st Spanish Edition",
        "BOOK",
        "Spanish",
        "1967",
        "Editorial Sudamericana",
        "978-0-06-088328-7",
        "863 G216 1967",
        "Latin American Literature, Magical Realism",
        "Colombia, family saga, magical realism",
        "spanish, classic, nobel prize",
        "417",
        "La obra maestra de García Márquez que narra la historia de la familia Buendía en el pueblo ficticio de Macondo.",
        "First Spanish edition",
        "Paperback, 417 páginas",
        "",
        "Special Collection",
      ],
      // Example 5: Journal/Periodical
      [
        "Nature - Vol 615, Issue 7950",
        "Multiple Contributors",
        "",
        "PERIODICAL",
        "English",
        "2023",
        "Nature Publishing Group",
        "",
        "505 N284 2023",
        "Science, Research, Biology, Physics",
        "peer-reviewed, scientific journal",
        "research, science, periodical",
        "200",
        "Weekly international journal publishing peer-reviewed research in all fields of science and technology.",
        "March 2023 Issue",
        "Magazine format",
        "Research Articles\nNews & Views\nLetters",
        "Subscription",
      ],
    ];

    // Create worksheet with column widths
    const worksheet = XLSX.utils.aoa_to_sheet(templateData);

    // Set column widths for better readability
    worksheet["!cols"] = [
      { wch: 30 }, // Title
      { wch: 35 }, // Author(s)
      { wch: 15 }, // Edition
      { wch: 12 }, // Document Type
      { wch: 10 }, // Language
      { wch: 13 }, // Published Year
      { wch: 25 }, // Publisher
      { wch: 18 }, // ISBN
      { wch: 18 }, // Call Number
      { wch: 35 }, // Subjects/Genre
      { wch: 30 }, // Keywords
      { wch: 25 }, // Tags
      { wch: 12 }, // Number of Pages
      { wch: 50 }, // Abstract/Description
      { wch: 30 }, // Notes/Additional Info
      { wch: 25 }, // Physical Description
      { wch: 40 }, // Table of Content
      { wch: 20 }, // Source
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Documents Template");

    // Write file
    XLSX.writeFile(workbook, "documents_import_template.xlsx");
  };

  // If a custom trigger is provided, use it; otherwise, use default button
  if (trigger) {
    return React.cloneElement(trigger, { onClick: downloadTemplate });
  }

  return (
    <Button
      primary
      icon="download"
      content="Download Template"
      onClick={downloadTemplate}
    />
  );
};

ExcelTemplate.propTypes = {
  trigger: PropTypes.element,
};

ExcelTemplate.defaultProps = {
  trigger: null,
};

export default ExcelTemplate;
